<template>
    <div>
        <label :style="'color:' + fieldsColor" :class="{'required': field.required || path.required}"
               v-if="path.hideTitle === undefined || !path.hideTitle">
            {{ field.name }}
            <img :src="path.small_icon"
                   height="20px"
                   v-if="path.small_icon !== undefined">
            <help-tooltip :content="field.helpDescription"></help-tooltip>
        </label>

        <div class="d-flex">
            <div :class="{'required': field.required }" v-if="path.icon !== undefined">
                <v-img :src="path.icon"
                       class="mr-5"
                       style="border-radius: 50px"
                       height="50px"
                       width="50px">
                </v-img>
            </div>

            <v-text-field
              :value="fieldValue"
              @input="updateFieldValue"
              :autocomplete="fieldCode"
              outlined
              hide-details
              :placeholder="!readOnly ? placeholder : ''"
              :class="{'input-error': !isValidFormat || (submitted && field.required && (fieldValue === null || fieldValue === ''))}"
              :readonly="readOnly"
            >
                <template v-slot:append>
                    <v-tooltip bottom
                               v-if="path.formats && isValidFormat && fieldValue !== null && fieldValue !== ''
                               && !Array.isArray(fieldValue) ">
                        <template v-slot:activator="{ on }">
                            <a @click="openUrl(fieldValue)" target="_blank" v-on="on" class="pro-link">
                                <v-icon :color="primaryColor">open_in_new</v-icon>
                            </a>
                        </template>
                        <div>Ouvrir dans un nouvel onglet</div>
                    </v-tooltip>

                    <v-tooltip bottom v-else-if="!isValidFormat">
                        <template v-slot:activator="{ on }">
                            <a v-on="on" class="pro-link">
                                <v-icon color="error">info</v-icon>
                            </a>
                        </template>
                        <div>{{ path.formatError }}</div>
                    </v-tooltip>
                </template>
            </v-text-field>
        </div>
    </div>
</template>

<script>
import HelpTooltip from "../../../tools/HelpTooltip.vue"

import { mapGetters, mapMutations, mapState } from "vuex"
import { fieldsMapping } from "../../../../static/webform"

export default {
    name: "FormText",
    props: ["field", "data"],
    components: { HelpTooltip },
    methods: {
        ...mapMutations("web_form", ["updateProviderFieldValue", "setDirtyTabulation"]),
        updateFieldValue(value) {
            if (this.data) {
                this.data[this.path.property] = value
            } else {
                this.updateProviderFieldValue([this.path, value])
            }

            this.setDirtyTabulation(this.field.tabulation.code)
        },
        openUrl(url) {
            let formattedUrl = url

            if (!/^https?:\/\//i.test(url)) {
                formattedUrl = "https://" + formattedUrl
            }

            window.open(formattedUrl, "_blank", "noopener,noreferrer")
        },
    },
    computed: {
        ...mapState("webFormStyle", ["fieldsColor", "primaryColor"]),
        ...mapState("web_form", ["submitted", "provider", "readOnly"]),
        ...mapGetters("web_form", ["getCodeFromField", "getProviderFieldValue"]),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        path() {
            return fieldsMapping.find(path => path.code === this.fieldCode)
        },
        fieldValue() {
            let value = null

            if (this.data) {
                value = this.data[this.path.property]
            } else {
                value = this.getProviderFieldValue(this.path)
            }

            return value
        },
        placeholder() {
            return this.path.placeholder !== undefined ? this.path.placeholder : null
        },
        isValidFormat() {
            let isValid = false

            if (this.path.formats !== undefined) {
                this.path.formats.forEach(format => {
                    isValid = isValid || new RegExp(format).test(this.fieldValue)
                })
            } else {
                isValid = true
            }

            return isValid || this.fieldValue === null || this.fieldValue === "" || this.fieldValue.length === 0
        },
    },
}
</script>